module.exports = __webpack_public_path__ + "media/Start.12fb44c4.mp4";